<template>
  <div :class="{ hidden: hidden }" class="pagination-container">
    <!-- v-model:current-page="currentPage" -->
    <!-- v-model:page-size="pageSize" -->
    <el-pagination
      :background="background"
      :current-page="currentPage"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      :small="small"
      :pager-count="pagerCount"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue'
import { scrollTo } from '@/utils/scroll-to'

const props = defineProps({
  total: {
    required: true,
    type: Number as PropType<number>,
    default: 0,
  },
  small: {
    required: false,
    type: Boolean,
    default: false,
  },
  pagerCount: {
    required: false,
    type: Number,
    default: 7,
  },
  page: {
    type: Number,
    default: 1,
  },
  limit: {
    type: Number,
    default: 20,
  },
  pageSizes: {
    type: Array as PropType<number[]>,
    default() {
      return [10, 20, 30, 50]
    },
  },
  layout: {
    type: String,
    default: 'total, sizes, prev, pager, next, jumper',
  },
  background: {
    type: Boolean,
    default: true,
  },
  autoScroll: {
    type: Boolean,
    default: true,
  },
  hidden: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:page', 'update:limit', 'pagination'])

const currentPage = computed<number | undefined>({
  get: () => props.page,
  set: (value) => {
    emit('update:page', value)
  },
})

const pageSize = computed<number | undefined>({
  get() {
    return props.limit
  },
  set(val) {
    emit('update:limit', val)
  },
})

function handleSizeChange(val: number) {
  pageSize.value = val
  emit('pagination', { page: currentPage, limit: val })
  if (props.autoScroll) {
    scrollTo(0, 800)
  }
}

function handleCurrentChange(val: number) {
  currentPage.value = val
  emit('pagination', { page: val, limit: props.limit })
  if (props.autoScroll) {
    scrollTo(0, 800)
  }
}
</script>

<style scoped>
.pagination-container {
  background: #fff;
  padding: 24px 16px;
}

.pagination-container.hidden {
  display: none;
}
</style>
